package dev.lingvo.site.nav

/**
 * The mark a navigation destination draws beside its label.
 *
 * **It lives in the nav model rather than in the shell that draws it, and that is the whole point.**
 * The choice used to be a `when (id)` inside `AppShell.kt` with an `else -> LGlobeIcon()` fallback,
 * so a destination added to [AppNav] and forgotten there still compiled and still rendered — as a
 * globe. That happened: the project rail arrived with eight destinations, every one of them missed
 * the `when`, and the rail drew eight identical globes carrying no information at all. A comment
 * above the fallback predicted exactly that failure and could not stop it, because a comment cannot
 * fail a build.
 *
 * With the mark on [AppDestination] as a non-null field with no default, the compiler stops it. The
 * enum is the contract between the model, which knows what a destination *means*, and the frontend,
 * which knows which icon file to render — `:kit` cannot draw the icons for `:site` here, because the
 * design system's icon composables are Compose HTML and this file is read by plain Kotlin tests.
 *
 * Names are the *icon's*, not the destination's, so that two destinations sharing a name in this
 * enum are visibly two destinations sharing a mark. That is what `NavIconCoverageTest` asserts about
 * within a single rail, and it can only be asserted on names that mean one drawing.
 */
enum class NavGlyph {
    ArrowUpDown,
    Bell,
    BookOpen,
    Bot,
    Box,
    Chart,
    ChartLine,
    Check,
    Coins,
    Comment,
    CreditCard,
    Danger,
    Download,
    ExternalLink,
    File,
    Files,
    Folder,
    Globe,
    Grid,
    Help,
    History,
    Key,
    Languages,
    ListChecks,
    Lock,
    Mail,
    Receipt,
    ScrollText,
    Settings,
    Smartphone,
    Sparkle,
    SquareCheck,
    Trash,
    User,
    Users,
    Webhook,
    Wrench,
}
